/**
 * Backend Configuration
 * Contains the backend API URL and other configuration
 */

export const BACKEND_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'https://apsrecruiting.io/api',
} as const;
